var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _vm.color
            ? _c(
                "v-flex",
                { attrs: { xs12: "", md8: "", "offset-md2": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        to: "/colours/" + _vm.color.fabric._id
                      }
                    },
                    [_vm._v("Back to " + _vm._s(_vm.color.fabric.name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("h4", [
                            _vm._v(
                              _vm._s(_vm.color.fabric.name) +
                                " - " +
                                _vm._s(_vm.color.name)
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-spacer")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c("h2", { staticClass: "headline" }, [
                            _vm._v("Tags")
                          ]),
                          _vm._v(" "),
                          _c("v-data-iterator", {
                            attrs: {
                              items: _vm.color.tags,
                              "content-tag": "v-layout",
                              row: "",
                              wrap: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function(props) {
                                    return _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c(
                                          "v-list",
                                          { attrs: { dense: "" } },
                                          [
                                            _c(
                                              "v-list-tile",
                                              [
                                                _c("v-list-tile-content", [
                                                  _vm._v(
                                                    _vm._s(props.item.name)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-tile-content",
                                                  { staticClass: "align-end" },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.deleteTag(
                                                              _vm.color._id,
                                                              props.index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("delete")
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              2833971039
                            )
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: _vm.availableTags,
                              "item-text": "label",
                              "item-value": "_id",
                              label: "Add Tag"
                            },
                            model: {
                              value: _vm.newTag,
                              callback: function($$v) {
                                _vm.newTag = $$v
                              },
                              expression: "newTag"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.addTag(_vm.color._id, _vm.newTag)
                                }
                              }
                            },
                            [_vm._v("Add")]
                          ),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              placeholder: "Colour Position (1 is highest)"
                            },
                            model: {
                              value: _vm.color.position,
                              callback: function($$v) {
                                _vm.$set(_vm.color, "position", $$v)
                              },
                              expression: "color.position"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.updateColor()
                                }
                              }
                            },
                            [_vm._v("Update")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.color
            ? _c(
                "v-flex",
                { attrs: { xs12: "", md8: "", "offset-md2": "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("h4", [_vm._v("Image")]),
                          _vm._v(" "),
                          _c("v-spacer")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c(
                          "form",
                          {
                            attrs: {
                              enctype: "multipart/form-data",
                              novalidate: ""
                            }
                          },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-xl": "", fluid: "" } },
                              [
                                _c("p", [
                                  _vm._v(
                                    "Upload a 500x500 fabric image here, a 110x110 thumbnail will be generated."
                                  )
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: {
                                    type: "file",
                                    name: "image",
                                    accept: "image/*"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.uploadFile(
                                        $event.target.name,
                                        $event.target.files,
                                        "large"
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      [
                                        _c("p", [
                                          _vm._v("Large Image (500x500):")
                                        ]),
                                        _vm._v(" "),
                                        _c("img", {
                                          staticStyle: {
                                            float: "left",
                                            "margin-right": "10px",
                                            "max-width": "100%"
                                          },
                                          attrs: {
                                            src: _vm.largeImageURL,
                                            width: "500"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("v-text-field", {
                                          attrs: { label: "Filename" },
                                          model: {
                                            value: _vm.color.largeImage,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.color,
                                                "largeImage",
                                                $$v
                                              )
                                            },
                                            expression: "color.largeImage"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      [
                                        _c("p", [
                                          _vm._v("Small Image (110x110):")
                                        ]),
                                        _vm._v(" "),
                                        _c("img", {
                                          staticStyle: {
                                            float: "left",
                                            "margin-right": "10px",
                                            "max-width": "100%"
                                          },
                                          attrs: {
                                            src: _vm.smallImageURL,
                                            width: "110"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("v-text-field", {
                                          attrs: { label: "Filename" },
                                          model: {
                                            value: _vm.color.smallImage,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.color,
                                                "smallImage",
                                                $$v
                                              )
                                            },
                                            expression: "color.smallImage"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4674ce51", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4674ce51","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/colours/EditColor.vue
// module id = null
// module chunks = 